import { geoDataCR } from "./json/geoDataCR";
import { geoDataPA } from "./json/geoDataPA";
import { geoDataMX } from "./json/geoDataMX";
import { geoDataCO } from "./json/geoDataCO";
import { geoDataNI } from "./json/geoDataNI";
import { geoDataGT } from "./json/geoDataGT";
import { Country } from "./models/Enums";

export interface IGeoDataStructure{
    key: string;
    name: string;
    ordinal: number;
}

export class GeoDataStructure {

    static country(country: Country): IGeoDataStructure[] {

        switch (country) {

            case Country.CR:
                return [
                    {key: 'provinces', name: 'provincia', ordinal: 1},
                    {key: 'cantons', name: 'cantón', ordinal: 2},
                    // {key: 'districts', name: 'distrito', ordinal: 3}
                ];

            case Country.PA:
                return [
                    {key: 'provinces', name: 'provincia', ordinal: 1},
                    {key: 'districts', name: 'distrito', ordinal: 2},
                    // {key: 'corregimientos', name: 'corregimientos', ordinal: 3}
                ];

            // Países nuevos: 2 niveles (estado/departamento + municipio)
            case Country.MX:
                return [
                    {key: 'states', name: 'estado', ordinal: 1},
                    {key: 'municipalities', name: 'municipio', ordinal: 2}
                ];

            case Country.CO:
            case Country.NI:
            case Country.GT:
                return [
                    {key: 'departments', name: 'departamento', ordinal: 1},
                    {key: 'municipalities', name: 'municipio', ordinal: 2}
                ];

            default:
                return [];
        }
    }

    static countryData(country: Country): any {

        switch (country) {

            case Country.CR:
                return {
                    provinces: geoDataCR.provinces,
                    cantons: geoDataCR.cantons,
                    districts: geoDataCR.districts,
                };

            case Country.PA:
                return {
                    provinces: geoDataPA.provinces,
                    districts: geoDataPA.districts,
                    corregimientos: geoDataPA.corregimientos,
                };

            case Country.MX:
                return {
                    states: geoDataMX.states,
                    municipalities: geoDataMX.municipalities,
                };

            case Country.CO:
                return {
                    departments: geoDataCO.departments,
                    municipalities: geoDataCO.municipalities,
                };

            case Country.NI:
                return {
                    departments: geoDataNI.departments,
                    municipalities: geoDataNI.municipalities,
                };

            case Country.GT:
                return {
                    departments: geoDataGT.departments,
                    municipalities: geoDataGT.municipalities,
                };

            default:
                return {};
        }
    }

}
